export enum CouponStatus {
  APPLIED = 'APPLIED',
  APPLICABLE = 'APPLICABLE',
  NON_APPLICABLE = 'NON_APPLICABLE',
}
